import React, { useState, useEffect, useCallback } from "react";
import DownloadModalTables from "../../components/DownloadModalTables";
import DateFilter from "../../components/DateFilter";
import PortalPopup from "../../components/PortalPopup";
import DebtorDeletion from "../../components/DebtorDeletion";
import ImagePreview from "../../components/ImagePreview";
import LBAReminder from "../../components/LBAReminder";
import NavigationDropdown from "../../components/NavigationDropdown";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import { useNavigate } from "react-router-dom";
import NavigationPanel from "../../components/NavigationPanel";
import CTAs from "../../components/CTAs";
import { useLocation } from "react-router-dom";
import "../../global.css";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Footer from "../../components/Footer.js";
import { getCurrentUser } from "../../utils/getCurrentUser";
import { debtorDetailsService } from "../../services/debtorDetailsService";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import { documentService } from "../../services/documentService";
import Chat from "../../components/Chat";
import Breadcrumb from "../../components/Breadcrumb.js";
import { Clock, Link21, Send2, TickCircle } from "iconsax-reactjs";

/* ── Styles ── */
const pageStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=DM+Mono:wght@400;500&display=swap');

  html, body { background: rgb(241, 245, 249) !important; }

  .ppld-root * { box-sizing: border-box; }
  .ppld-root {
    font-family: 'DM Sans', sans-serif;
    background: rgb(241, 245, 249) !important;
    min-height: 100vh;
  }
  .ppld-root.bg-neutrals-neutral-50,
  .ppld-root.bg-white,
  .ppld-root.bg-gray-50 { background: rgb(241, 245, 249) !important; }

  .ppld-card {
    background: #ffffff;
    border: 1px solid #E2E8F0;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 2px 12px rgba(0,0,0,0.04);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    position: relative;
    overflow: hidden;
  }
  .ppld-card:hover { box-shadow: 0 4px 24px rgba(0,0,0,0.09); }

  .ppld-metric-card { cursor: default; }
  .ppld-metric-card:hover { transform: translateY(-3px); }
  .ppld-metric-card .accent-bar {
    position: absolute; top: 0; left: 0; right: 0;
    height: 4px; border-radius: 16px 16px 0 0;
  }

  .ppld-section-title { font-size: 16px; font-weight: 700; color: #0F172A; }
  .ppld-section-sub   { font-size: 13px; color: #64748B; margin-top: 2px; }

  .ppld-table { width: 100%; border-collapse: collapse; }
  .ppld-table thead tr { background: #F8FAFC; }
  .ppld-table th {
    padding: 11px 16px; text-align: left;
    font-size: 11px; font-weight: 700; color: #94A3B8;
    text-transform: uppercase; letter-spacing: 0.07em;
    border-bottom: 1px solid #E2E8F0;
  }
  .ppld-table td {
    padding: 14px 16px; font-size: 14px; color: #1E293B;
    border-bottom: 1px solid #F1F5F9; vertical-align: middle;
  }
  .ppld-table tbody tr { transition: background 0.12s; }
  .ppld-table tbody tr:hover { background: #F8FAFC; }
  .ppld-table tbody tr:last-child td { border-bottom: none; }

  .ppld-search {
    display: flex; align-items: center; gap: 8px;
    background: #ffffff; border: 1px solid #E2E8F0; border-radius: 10px;
    padding: 9px 14px; box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    width: 280px; transition: border-color 0.15s, box-shadow 0.15s;
  }
  .ppld-search:focus-within { border-color: #2563EB; box-shadow: 0 0 0 3px rgba(37,99,235,0.1); }
  .ppld-search input {
    border: none; outline: none; background: transparent;
    font-family: 'DM Sans', sans-serif; font-size: 14px; color: #0F172A; width: 100%;
  }
  .ppld-search input::placeholder { color: #94A3B8; }

  .ppld-btn {
    display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px;
    background: #ffffff; border: 1px solid #E2E8F0; border-radius: 8px;
    font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 600; color: #1E293B;
    cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    transition: border-color 0.15s, background 0.15s, color 0.15s;
  }
  .ppld-btn:hover:not(:disabled) { border-color: #2563EB; background: #EFF6FF; color: #2563EB; }
  .ppld-btn:disabled { opacity: 0.45; cursor: not-allowed; }

  .ppld-btn-danger {
    display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px;
    background: #ffffff; border: 1px solid #FECACA; border-radius: 8px;
    font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 600; color: #DC2626;
    cursor: pointer; transition: border-color 0.15s, background 0.15s;
  }
  .ppld-btn-danger:hover { background: #FEF2F2; border-color: #DC2626; }

  .ppld-count-pill {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 3px 10px; background: #EFF6FF; border-radius: 20px;
    font-size: 12px; font-weight: 700; color: #2563EB;
  }

  .ppld-doc-card {
    width: 420px; background: #ffffff;
    border: 1px solid #E2E8F0; border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06); overflow: hidden;
    transition: box-shadow 0.2s, transform 0.2s;
    display: flex; flex-direction: column; justify-content: space-between;
  }
  .ppld-doc-card:hover { box-shadow: 0 6px 24px rgba(0,0,0,0.1); transform: translateY(-2px); }

  .ppld-spinner {
    width: 16px; height: 16px;
    border: 2px solid #E2E8F0; border-top-color: #2563EB;
    border-radius: 50%; animation: ppld-spin 0.7s linear infinite; flex-shrink: 0;
  }
  @keyframes ppld-spin { to { transform: rotate(360deg); } }
`;

/* ── FilePreviewModal — unchanged logic ── */
const FilePreviewModal = ({ fileUrl, fileType, content, title, onClose }) => {
  const renderContent = () => {
    switch (fileType) {
      case "pdf":
        return <iframe src={fileUrl} width="100%" height="600px" title="PDF Preview" style={{ border: "none", borderRadius: 8 }} />;
      case "jpg": case "jpeg": case "png": case "gif":
        return <img src={fileUrl} alt="Document Preview" style={{ maxWidth: "100%", maxHeight: 600, objectFit: "contain", borderRadius: 8 }} />;
      case "text":
        return (
          <div style={{ background: "#F8FAFC", padding: 16, borderRadius: 8, maxHeight: 600, overflow: "auto" }}>
            <pre style={{ margin: 0, fontSize: 13, whiteSpace: "pre-wrap", color: "#1E293B" }}>{content}</pre>
          </div>
        );
      default:
        return (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 32, gap: 16 }}>
            <p style={{ margin: 0, color: "#64748B" }}>This file type cannot be previewed.</p>
            {fileUrl && <a href={fileUrl} download style={{ padding: "8px 18px", background: "#2563EB", color: "#fff", borderRadius: 8, textDecoration: "none", fontWeight: 600 }}>Download File</a>}
          </div>
        );
    }
  };
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.5)" }}>
      <div style={{ background: "#fff", padding: 24, borderRadius: 16, maxWidth: 900, width: "100%", maxHeight: "90vh", overflow: "auto", position: "relative", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "#F1F5F9", border: "none", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 18, fontWeight: 700, color: "#64748B", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
        {title && <h3 style={{ margin: "0 0 16px", fontSize: 16, fontWeight: 700, color: "#0F172A" }}>{title}</h3>}
        {renderContent()}
      </div>
    </div>
  );
};

const PostPreLbaDetails = () => {
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] = useState(false);
  const [isDateFilterOpen, setDateFilterOpen] = useState(false);
  const [isDebtorDeletionOpen, setDebtorDeletionOpen] = useState(false);
  const [isImagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [isLBAReminderOpen, setLBAReminderOpen] = useState(false);
  const [isNavigationDropdownOpen, setNavigationDropdownOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [filePreview, setFilePreview] = useState(null);

  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { name, currency, amount, address } = location.state || {};
  const [email, setEmail] = useState("");
  const [documents, setDocuments] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  const [isSettling, setIsSettling] = useState(false);
  const [statuses, setStatuses] = useState({});
  const [communicationHistory, setCommunicationHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(true);
  const [selectedDateTimeRange, setSelectedDateTimeRange] = useState("");
  const [lawyerId, setLawyerId] = useState("");
  const [clientId, setClientId] = useState("");
  const [clientName, setClientName] = useState("");
  const [lbaId, setLbaId] = useState("");

  // Fetch communication history — unchanged
  useEffect(() => {
    const fetchCommunicationHistory = async () => {
      try {
        setLoadingHistory(true);
        const id = location.state.lbaId;
        const result = await debtorDetailsService.getCommunicationHistory(id);
        if (result.success) setCommunicationHistory(result.history);
      } catch (error) {
        console.error("Error fetching communication history:", error);
      } finally {
        setLoadingHistory(false);
      }
    };
    if (location.state.lbaId) fetchCommunicationHistory();
  }, [location.state.lbaId]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear().toString().slice(-2)}`;
  };

  const getFileIcon = (fileType) => {
    switch ((fileType || "").toLowerCase()) {
      case "pdf": return "assets/pdf.svg";
      case "docx": case "doc": return "assets/word_file.svg";
      default: return "assets/file.svg";
    }
  };

  const formatFileSize = (sizeInBytes) => {
    if (!sizeInBytes) return "0B";
    if (sizeInBytes < 1024) return `${sizeInBytes}B`;
    if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)}KB`;
    return `${(sizeInBytes / (1024 * 1024)).toFixed(1)}MB`;
  };

  // handlePreview — unchanged logic
  const handlePreview = async (document) => {
    try {
      const blob = await documentService.downloadDocument(document, true);
      if (blob) {
        const objectUrl = URL.createObjectURL(blob);
        const fileExtension = document.name ? document.name.split(".").pop().toLowerCase() : "pdf";
        setFilePreview({ url: objectUrl, type: fileExtension, blob });
      }
    } catch (error) {
      console.error("Service-based preview failed:", error);
      window.open(document.fileUrl, "_blank");
    }
  };

  // handleDownload — unchanged logic
  const handleDownload = async (document) => {
    try {
      if (typeof window === "undefined" || typeof document === "undefined") throw new Error("Download is only available in browser environment");
      await documentService.downloadDocument(document);
    } catch (error) {
      console.error("Error downloading file:", error);
      if (document.fileUrl) {
        try { await handleDirectDownload(document); }
        catch (fallbackError) { alert(`Failed to download the file: ${error.message}.`); }
      } else {
        alert(`Failed to download the file: ${error.message}.`);
      }
    }
  };

  const handleDirectDownload = async (doc) => {
    const response = await fetch(doc.fileUrl, { method: "GET", credentials: "include" });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const blob = await response.blob();
    if (blob.size === 0) throw new Error("Downloaded file is empty");
    const url = window.URL.createObjectURL(blob);
    const link = window.document.createElement("a");
    link.href = url; link.download = doc.name || "document";
    window.document.body.appendChild(link); link.click();
    window.URL.revokeObjectURL(url); window.document.body.removeChild(link);
  };

  const handleSimpleDownload = (doc) => {
    if (doc.fileUrl) window.open(doc.fileUrl, "_blank");
    else throw new Error("No file URL available");
  };

  // handleDownloadAll — unchanged logic
  const handleDownloadAll = async () => {
    try {
      const id = location.state?.lbaId;
      if (!id) { alert("No LBA ID found for download"); return; }
      if (documents.length === 0) { alert("No documents available for download."); return; }
      await documentService.downloadAllDocuments(id);
    } catch (error) {
      console.error("Error downloading ZIP:", error);
      alert("Failed to download files. Please try again.");
    }
  };

  // handleDownloadAllAsZip — with duplicate-name deduplication fix
  const handleDownloadAllAsZip = async () => {
    try {
      if (documents.length === 0) { alert("No documents available for download."); return; }
      const zip = new JSZip();
      const usedNames = new Set();
      const uniqueName = (rawName, idx) => {
        const lastDot = rawName.lastIndexOf(".");
        const base = lastDot !== -1 ? rawName.slice(0, lastDot) : rawName;
        const ext  = lastDot !== -1 ? rawName.slice(lastDot)    : "";
        let candidate = rawName;
        if (usedNames.has(candidate)) candidate = `${base}_${idx}${ext}`;
        let counter = 2;
        while (usedNames.has(candidate)) { candidate = `${base}_${idx}_${counter}${ext}`; counter++; }
        usedNames.add(candidate);
        return candidate;
      };
      let hasFiles = false;
      for (let i = 0; i < documents.length; i++) {
        const doc = documents[i];
        try {
          const response = await fetch(doc.fileUrl, {
            credentials: "include",
            headers: documentService._getAuthHeaders ? documentService._getAuthHeaders() : {},
          });
          if (!response.ok) { console.warn(`Failed to fetch ${doc.name}: ${response.status}`); continue; }
          const blob = await response.blob();
          if (blob.size > 0) { zip.file(uniqueName(doc.name || `file_${i}.pdf`, i), blob); hasFiles = true; }
        } catch (error) { console.error(`Error downloading ${doc.name || "file"} for ZIP:`, error); }
      }
      if (!hasFiles) { alert("No files could be downloaded."); return; }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `Documents-${new Date().toISOString().split("T")[0]}.zip`);
    } catch (error) {
      alert("Failed to create download package. Please try downloading files individually.");
    }
  };

  // fetchInitialData — unchanged logic
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        const user = getCurrentUser();
        const storedUserId = location.state?.userId;
        const id = location.state?.lbaId;
        setClientId(user?.companyId);
        setLbaId(id);
        if (!id) { console.error("LBA ID is missing from location state"); return; }
        if (user?.email) setEmail(user.email);
        if (storedUserId) {
          const statusResponse = await debtorDetailsService.getLbaStatus(id, storedUserId);
          if (statusResponse.success) {
            setStatuses((prev) => ({ ...prev, [id]: statusResponse.status === "Resolved" ? "Settled" : statusResponse.status }));
            setLawyerId(statusResponse.lawyerId);
            setClientName(statusResponse.companyName);
          }
        }
        const documentsResponse = await documentService.getDocuments(id);
        if (documentsResponse.documents && Array.isArray(documentsResponse.documents)) {
          setDocuments(documentsResponse.documents);
        } else {
          console.warn("Expected array of documents but got:", documentsResponse);
          setDocuments([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        alert(`Error loading documents: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    if (location.state?.lbaId) fetchInitialData();
    else { console.error("No LBA ID found in location state"); setLoading(false); }
  }, [location.state?.lbaId, location.state?.userId]);

  // handleMarkAsSettled — unchanged logic
  const handleMarkAsSettled = async () => {
    try {
      setIsSettling(true);
      const id = location.state?.lbaId;
      const userId = location.state?.userId;
      if (!id || !userId) { alert("Missing LBA ID or User ID"); return; }
      const result = await debtorDetailsService.markAsSettled(id, userId);
      if (result.success) {
        setStatuses((prev) => ({ ...prev, [id]: result.status || "Settled" }));
        alert(result.message || "Status updated successfully!");
      }
    } catch (error) { alert(`Error: ${error.message}`); }
    finally { setIsSettling(false); }
  };

  // fetchStatus — unchanged logic
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const id = location.state?.lbaId;
        const userId = location.state?.userId;
        if (!id || !userId) return;
        const statusResponse = await debtorDetailsService.getLbaStatus(id, userId);
        if (statusResponse.success) {
          setStatuses((prev) => ({ ...prev, [id]: statusResponse.status === "Resolved" ? "Settled" : statusResponse.status }));
        }
      } catch (error) { console.error("Error fetching status:", error); }
    };
    if (location.state?.lbaId && location.state?.userId) fetchStatus();
  }, [location.state?.lbaId, location.state?.userId]);

  const openDateFilter           = useCallback(() => setDateFilterOpen(true),  []);
  const closeDateFilter          = useCallback(() => setDateFilterOpen(false), []);
  const handleDateTimeSelect     = (dateRange) => { setSelectedDateTimeRange(dateRange); };
  const [filteredHistory, setFilteredHistory] = useState([]);

  const mergeDateTime = (dateStr, timeStr) => new Date(`${dateStr} ${timeStr}`);

  useEffect(() => {
    if (!communicationHistory || !selectedDateTimeRange) return;
    const { startDate, endDate, fromTime, toTime } = selectedDateTimeRange;
    const start = mergeDateTime(startDate, fromTime);
    const end   = mergeDateTime(endDate, toTime);
    setFilteredHistory(communicationHistory.filter((item) => {
      const created = new Date(item.createdAt);
      return created >= start && created <= end;
    }));
  }, [communicationHistory, selectedDateTimeRange]);

  const dataToDisplay = selectedDateTimeRange ? filteredHistory : communicationHistory;

  const openDownloadModalTables  = useCallback(() => setDownloadModalTablesOpen(true),  []);
  const closeDownloadModalTables = useCallback(() => setDownloadModalTablesOpen(false), []);
  const onFrameContainerClick    = useCallback(() => navigate("/"), [navigate]);
  const openDebtorDeletion       = useCallback(() => setDebtorDeletionOpen(true),  []);
  const closeDebtorDeletion      = useCallback(() => setDebtorDeletionOpen(false), []);
  const openImagePreview         = useCallback(() => setImagePreviewOpen(true),  []);
  const closeImagePreview        = useCallback(() => setImagePreviewOpen(false), []);
  const openLBAReminder          = useCallback(() => setLBAReminderOpen(true),  []);
  const closeLBAReminder         = useCallback(() => setLBAReminderOpen(false), []);
  const closeNavigationDropdown  = useCallback(() => setNavigationDropdownOpen(false), []);
  const closeLogoutConfirmation  = useCallback(() => setLogoutConfirmationOpen(false), []);

  const lawyer = location.state?.lawyer === true;
  const displayEmail = lawyer ? location.state?.email : email;

  const userNavItems = [
    { text: "Debt collection", bgColor: "bg-primary-primary-50", textColor: "text-neutrals-neutral-900", hoverBgColor: "bg-primary-primary-50", hoverTextColor: "text-neutrals-neutral-900", path: "", icon: "assets/arrow-down.svg" },
    { text: "Outcomes & costs", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/outcome&cost", icon: "" },
    { text: "AI indicators", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/ai1", icon: "" },
  ];
  const lawyerNavItems = [
    { text: "Dashboard", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/dashboard" },
    { text: "Legal proceedings & billing", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/legal_1" },
    { text: "Pre-LBA checks", bgColor: "bg-primary-primary-50", textColor: "text-neutrals-neutral-900", hoverBgColor: "bg-primary-primary-50", hoverTextColor: "text-neutrals-neutral-900", path: "/prelbacheck" },
    { text: "Client-debtor interaction", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/cdi1" },
  ];
  const breadcrumbs = [
    { label: "Post Pre-Letter before action (LBA)", path: "/postlba", active: false },
    { label: location.state?.name || "Debtor details", path: "", active: true },
  ];
  const navItems = lawyer ? lawyerNavItems : userNavItems;
  const Panel = lawyer ? NavigationPanelLawyer : NavigationPanel;
  const currentStatus = statuses[location.state?.lbaId] || "Unsettled";

  /* ─────────────────────── RENDER ─────────────────────── */
  return (
    <>
      <style>{pageStyles}</style>

      <div
        className="ppld-root w-full overflow-visible"
        style={{ background: "rgb(241, 245, 249)", minHeight: "100vh" }}
      >
        <Panel navItems={navItems} />

        <div style={{ position: "absolute", top: 136, width: "100%", padding: "0 96px 64px", display: "flex", flexDirection: "column", gap: 28 }}>

          {/* ── Breadcrumb ── */}
          <Breadcrumb breadcrumbs={breadcrumbs} />

          {/* ── Page heading + delete ── 
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: 24, borderBottom: "1px solid #E2E8F0" }}>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#0F172A" }}>Debtor details</h1>
            <button className="ppld-btn-danger" onClick={openDebtorDeletion}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M21 5.98c-3.33-.33-6.68-.5-10.02-.5-1.98 0-3.96.1-5.94.3L3 5.98M8.5 4.97l.22-1.31C8.88 2.71 9 2 10.69 2h2.62c1.69 0 1.82.75 1.97 1.67l.22 1.3M18.85 9.14l-.65 10.07C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 19.21L5.15 9.14M10.33 16.5h3.33M9.5 12.5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Delete
            </button>
          </div>*/}

          {/* ── Two metric boxes (Amount Due + Risk Level) — same as original ── */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
            <div className="ppld-card ppld-metric-card" style={{ padding: 24 }}>
              <div className="accent-bar" style={{ background: "#7C3AED" }}/>
              <div style={{ marginTop: 8 }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: "#F5F3FF", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18, border: "1px solid #E2E8F0" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9.5 13.75c0 .97.75 1.75 1.67 1.75h1.88c.8 0 1.45-.68 1.45-1.53 0-.91-.4-1.24-.99-1.45l-3.01-1.05c-.59-.21-.99-.53-.99-1.45 0-.84.65-1.53 1.45-1.53h1.88c.92 0 1.67.78 1.67 1.75M12 7.5v9" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Amount Due</div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 28, fontWeight: 500, color: "#0F172A", lineHeight: 1.1 }}>
                  {location.state?.amount ? `£${location.state.amount.toString().replace(/£/g, "")}` : "—"}
                </div>
              </div>
            </div>

            <div className="ppld-card ppld-metric-card" style={{ padding: 24 }}>
              <div className="accent-bar" style={{ background: "#F59E0B" }}/>
              <div style={{ marginTop: 8 }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: "#FFFBEB", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18, border: "1px solid #E2E8F0" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 9v5M12 21.41H5.94c-3.47 0-4.92-2.48-3.24-5.51l3.12-5.62L8.76 5c1.78-3.21 4.7-3.21 6.48 0l2.94 5.29 3.12 5.62c1.68 3.03.22 5.51-3.24 5.51H12v-.01Z" stroke="#D97706" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M11.995 17h.009" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Risk Level</div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 28, fontWeight: 500, color: "#0F172A", lineHeight: 1.1 }}>
                  {location.state?.risk || "—"}
                </div>
              </div>
            </div>
          </div>

          {/* ── Communication history ── */}
          <div className="ppld-card" style={{ overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #E2E8F0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span className="ppld-section-title">Communication history</span>
                <span className="ppld-count-pill">
                  <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563EB", display: "inline-block" }}/>
                  {dataToDisplay.length} {dataToDisplay.length === 1 ? "entry" : "entries"}
                </span>
              </div>
              <button className="ppld-btn" onClick={openDownloadModalTables}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M9 11v6l2-2M9 17l-2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Download
              </button>
            </div>

            <div style={{ padding: "12px 24px", borderBottom: "1px solid #F1F5F9", background: "#FAFBFD", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div className="ppld-search">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                  <path d="M11.5 21a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM22 22l-2-2" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input type="text" placeholder="Search" readOnly/>
              </div>
              <button className="ppld-btn" onClick={openDateFilter}>
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none">
                  <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Filter
              </button>
            </div>

            {/* Table — Date+Time and Description only, matching the original exactly */}
            <div style={{ overflowX: "auto" }}>
              <table className="ppld-table">
                <thead>
                  <tr>
                    <th>Date &amp; Time</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingHistory ? (
                    <tr><td colSpan="2" style={{ textAlign: "center", color: "#94A3B8", padding: 40 }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        <div className="ppld-spinner"/> Loading…
                      </div>
                    </td></tr>
                  ) : dataToDisplay.length === 0 ? (
                    <tr><td colSpan="2" style={{ textAlign: "center", color: "#94A3B8", padding: 40 }}>No communication history</td></tr>
                  ) : (
                    dataToDisplay.map((entry, index) => (
                      <tr key={entry._id || index}>
                        <td style={{ whiteSpace: "nowrap", color: "#64748B", fontSize: 13 }}>
                          {new Date(entry.createdAt).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true })}
                        </td>
                        <td>{entry.description}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── Attached documents ── */}
          <div className="ppld-card" style={{ overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #E2E8F0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div>
                <div className="ppld-section-title">Attached documents</div>
                <div className="ppld-section-sub">List of all attached documents.</div>
              </div>
              <button className="ppld-btn" onClick={handleDownloadAllAsZip}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M9 11v6l2-2M9 17l-2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Download all
              </button>
            </div>

            <div style={{ padding: 24, display: "flex", flexWrap: "wrap", gap: 24 }}>
              {loading ? (
                <div style={{ display: "flex", alignItems: "center", gap: 10, color: "#64748B", fontSize: 14 }}>
                  <div className="ppld-spinner"/> Loading documents…
                </div>
              ) : documents.length === 0 ? (
                <div style={{ color: "#94A3B8", fontSize: 14 }}>No documents found</div>
              ) : (
                documents.map((doc, index) => (
                  <div key={doc.id || index} className="ppld-doc-card">
                    {/* Header — same info as original: icon, name, date, size */}
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: 24 }}>
                      <img style={{ width: 40, height: 40, flexShrink: 0 }} alt="" src={getFileIcon(doc.name?.split(".").pop() || "default")}/>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                          <span style={{ fontWeight: 700, fontSize: 14, color: "#0F172A", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>
                            {doc.name && doc.name.length > 21 ? `${doc.name.substring(0, 21)}…` : doc.name || "Unnamed File"}
                          </span>
                          <span style={{ fontSize: 12, color: "#94A3B8", flexShrink: 0 }}>{doc.date || "N/A"}</span>
                        </div>
                        <div style={{ fontSize: 13, color: "#94A3B8", marginTop: 2 }}>{doc.formattedSize || formatFileSize(doc.size)}</div>
                      </div>
                    </div>
                    {/* Footer — Preview + Download buttons, same as original */}
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "14px 24px", borderTop: "1px solid #E2E8F0", background: "#FAFBFD" }}>
                      <button className="ppld-btn" onClick={() => handlePreview(doc)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                          <path d="M15.58 12c0 1.98-1.6 3.58-3.58 3.58S8.42 13.98 8.42 12s1.6-3.58 3.58-3.58 3.58 1.6 3.58 3.58Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M12 20.27c3.53 0 6.82-2.08 9.11-5.68.9-1.41.9-3.78 0-5.19-2.29-3.6-5.58-5.68-9.11-5.68-3.53 0-6.82 2.08-9.11 5.68-.9 1.41-.9 3.78 0 5.19 2.29 3.6 5.58 5.68 9.11 5.68Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Preview
                      </button>
                      <button className="ppld-btn" onClick={() => handleDownload(doc)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                          <path d="M9 11v6l2-2M9 17l-2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                ))
              )}

              {isImagePreviewOpen && (
                <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeImagePreview}>
                  <ImagePreview onClose={closeImagePreview}/>
                </PortalPopup>
              )}
              {filePreview && (
                <FilePreviewModal fileUrl={filePreview.url} fileType={filePreview.type} onClose={() => setFilePreview(null)}/>
              )}
            </div>
          </div>

          {/* ── Notes — same text as original ── */}
          <div className="ppld-card" style={{ overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #E2E8F0" }}>
              <div className="ppld-section-title">Notes</div>
            </div>
            <div style={{ padding: "16px 24px", display: "flex", flexDirection: "column", gap: 4 }}>
              <div style={{ fontSize: 13, color: "#64748B" }}>Notes</div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#0F172A" }}>
                This debtor has an history of late payments.
              </div>
            </div>
          </div>

          {/* ── Chat window — same as original ── */}
          <div className="ppld-card" style={{ overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #E2E8F0" }}>
              <div className="ppld-section-title">Communication</div>
              <div className="ppld-section-sub">Chat with the lawyer regarding this case.</div>
            </div>
            <div>
              <Chat clientId={clientId} lawyerId={lawyerId} lbaId={lbaId} clientName={clientName}/>
            </div>
          </div>

          <Footer />
        </div>
      </div>

      {/* ── Modals — all unchanged ── */}
      {isDateFilterOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeDateFilter}>
          <DateFilter onClose={closeDateFilter} onDateTimeSelect={handleDateTimeSelect}/>
        </PortalPopup>
      )}
      {isDebtorDeletionOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeDebtorDeletion}>
          <DebtorDeletion onClose={closeDebtorDeletion}/>
        </PortalPopup>
      )}
      {isImagePreviewOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeImagePreview}>
          <ImagePreview onClose={closeImagePreview}/>
        </PortalPopup>
      )}
      {isDownloadModalTablesOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeDownloadModalTables}>
          <DownloadModalTables onClose={closeDownloadModalTables} tableData={communicationHistory} tag="comm"/>
        </PortalPopup>
      )}
      {isLBAReminderOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeLBAReminder}>
          <LBAReminder onClose={closeLBAReminder}/>
        </PortalPopup>
      )}
      {isNavigationDropdownOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeNavigationDropdown}>
          <NavigationDropdown onClose={closeNavigationDropdown}/>
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup overlayColor="rgba(113,113,113,0.3)" placement="Centered" onOutsideClick={closeLogoutConfirmation}>
          <LogoutConfirmation onClose={closeLogoutConfirmation}/>
        </PortalPopup>
      )}
    </>
  );
};

export default PostPreLbaDetails;